import { ROUTES } from 'constants/routes';

const COMPANY_SCOPED_ROUTE =
  /^\/empresa\/([^/]+)\/(dashboard|notificaciones|documentos|banking|impuestos|perks|servicios|invoices|command|back-office)(.*)$/;
const COMPANY_PROFILE_ROUTE = /^\/empresa\/empresas\/([^/]+)\/perfil(.*)$/;

export function buildCompanyScopedRoute(pathname, companyId) {
  const profileMatch = pathname.match(COMPANY_PROFILE_ROUTE);

  if (profileMatch) {
    return `${ROUTES.PERFIL_EMPRESA(companyId)}${profileMatch[2] || ''}`;
  }

  const match = pathname.match(COMPANY_SCOPED_ROUTE);

  if (!match) {
    return ROUTES.COMPANY_DASHBOARD(companyId);
  }

  const subpath = match[2];
  const rest = match[3] || '';
  return `/empresa/${companyId}/${subpath}${rest}`;
}
